<template>
  <div v-show="error" class="pl-1 pt-1 text-xs text-error-content">
    {{ errorMsg }}
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import type { ValidationResult } from '@core/utils/forms/rules';

  export interface MFormControlErrorProps {
    error?: string | (string | ValidationResult)[];
  }
  const props = defineProps<MFormControlErrorProps>();

  const errorMsg = computed(() => {
    if (Array.isArray(props.error) && props.error.length) {
      return props.error.map((e) => (typeof e === 'string' ? e : e.error)).join();
    } else {
      return props.error;
    }
  });
</script>
